var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleLoader = function SvgSimpleLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D1D1",
    d: "M14.667 8A6.667 6.667 0 1 1 1.334 8a6.667 6.667 0 0 1 13.333 0m-11 0a4.333 4.333 0 1 0 8.667 0 4.333 4.333 0 0 0-8.667 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M8 1.333A6.667 6.667 0 0 1 14.667 8h-2.333A4.333 4.333 0 0 0 8 3.667z"
  })));
};
export default SvgSimpleLoader;